import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Controls from './pages/Controls';
import Evidence from './pages/Evidence';
import Incidents from './pages/Incidents';
import Products from './pages/Products';
import Reports from './pages/Reports';
import Insights from './pages/Insights';
import CMDB from './pages/CMDB';
import Security from './pages/Security';
import Operations from './pages/Operations';
import FinOps from './pages/FinOps';
import Support from './pages/Support';
import Events from './pages/Events';
import Approvals from './pages/Approvals';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        {/* Operations */}
        <Route path="security" element={<Security />} />
        <Route path="operations" element={<Operations />} />
        <Route path="incidents" element={<Incidents />} />
        <Route path="support" element={<Support />} />
        <Route path="events" element={<Events />} />
        <Route path="approvals" element={<Approvals />} />
        {/* Compliance */}
        <Route path="controls" element={<Controls />} />
        <Route path="evidence" element={<Evidence />} />
        {/* Portfolio */}
        <Route path="products" element={<Products />} />
        <Route path="cmdb" element={<CMDB />} />
        <Route path="finops" element={<FinOps />} />
        {/* Analytics */}
        <Route path="insights" element={<Insights />} />
        <Route path="reports" element={<Reports />} />
      </Route>
    </Routes>
  );
}
